import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../../public/img/confidoLegal.png';
import _imports_1 from '../../../../public/img/confido_logo.png';
const _hoisted_1 = {
  class: "text-center"
};
const _hoisted_2 = {
  class: "py-4"
};
const _hoisted_3 = {
  class: "py-4"
};
const _hoisted_4 = {
  class: "items-center",
  style: {
    "padding": "5px",
    "width": "220px",
    "margin": "0 auto"
  }
};
const _hoisted_5 = {
  class: "text-center"
};
const _hoisted_6 = {
  class: "flex w-full p-4"
};
const _hoisted_7 = {
  class: "w-1/12"
};
const _hoisted_8 = {
  class: "fa fa-check"
};
const _hoisted_9 = {
  class: "fa fa-warning"
};
const _hoisted_10 = {
  class: "w-11/12"
};
const _hoisted_11 = {
  class: "flex w-full p-4"
};
const _hoisted_12 = {
  class: "w-1/12"
};
const _hoisted_13 = {
  class: "fa fa-check"
};
const _hoisted_14 = {
  class: "fa fa-warning"
};
const _hoisted_15 = {
  class: "w-11/12"
};
const _hoisted_16 = {
  class: "flex w-full p-4"
};
const _hoisted_17 = {
  class: "w-1/12"
};
const _hoisted_18 = {
  class: "fa fa-check"
};
const _hoisted_19 = {
  class: "fa fa-minus"
};
const _hoisted_20 = {
  class: "w-11/12"
};
const _hoisted_21 = {
  class: "flex w-full p-4"
};
const _hoisted_22 = {
  class: "w-1/12"
};
const _hoisted_23 = {
  class: "fa fa-check"
};
const _hoisted_24 = {
  class: "fa fa-minus"
};
const _hoisted_25 = {
  class: "w-11/12"
};
const _hoisted_26 = {
  class: "mt-4"
};
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useGravityValidationStore } from '@/services/useGravityValidationStore';
import Loader from '@/components/Loader.vue';
import { reactive, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'GravityIntegration',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      loadMyCompany,
      updateMyCompany
    } = useCompanyStore();
    const {
      company
    } = storeToRefs(useMeStore());
    const {
      getMe
    } = useMeStore();
    const {
      validateConfidoEnabled
    } = useGravityValidationStore();
    const {
      confidoValidation
    } = storeToRefs(useGravityValidationStore());
    const companyStore = useCompanyStore();
    const meStore = useMeStore();
    companyStore.alerts = props.alerts;
    meStore.alerts = props.alerts;
    const gravityState = reactive({
      gravity: {},
      sandbox: false,
      validating: false,
      validation: {},
      valid: false,
      saving: false
    });
    onMounted(async () => {
      await getMe();
      await loadMyCompany();
      hydrateAndValidate();
    });
    function hydrateAndValidate() {
      gravityState.gravity = companySettings.value.gravity || {};
      gravityState.sandbox = gravityState.gravity.env === 'sandbox';
      validate();
    }
    function validate() {
      if (gravityState.gravity.enabled) {
        gravityState.validating = true;
        validateConfidoEnabled().then(() => {
          // Map the values from store to local state
          gravityState.validation = {
            customer: confidoValidation.value.customer,
            ccProcessing: confidoValidation.value.ccProcessing,
            achProcessing: confidoValidation.value.achProcessing,
            validToken: confidoValidation.value.validToken
          };
          const {
            customer,
            ccProcessing,
            achProcessing,
            validToken
          } = gravityState.validation || {};
          gravityState.valid = customer && (ccProcessing || achProcessing) && validToken;
        }).catch(err => {
          props.alerts.error(err);
          gravityState.valid = false;
        }).finally(() => {
          gravityState.validating = false;
        });
      }
      gravityState.enabling = false;
    }
    function signUpToConfido() {
      window.location.href = `${props.leanLawAuth.domain}/gravity/signup?sandbox=${gravityState.sandbox}&redirect=${encodeURIComponent(window.location.href)}`;
    }
    function partnerConnect() {
      window.location.href = `${props.leanLawAuth.domain}/gravity/partnerconnect?sandbox=${gravityState.sandbox}&redirect=${encodeURIComponent(window.location.href)}`;
    }
    function disable() {
      gravityState.saving = true;
      gravityState.gravity.enabled = false;
      gravityState.gravity.key = '';
      gravityState.gravity.env = gravityState.sandbox ? 'sandbox' : '';
      updateMyCompany({
        settings: {
          gravity: gravityState.gravity
        }
      }).then(company => {
        gravityState.gravity = company.settings.gravity;
        validate();
        props.alerts.success(`Confido Legal was disconnected`);
      }).catch(err => {
        props.alerts.error(err);
      }).finally(() => {
        gravityState.saving = false;
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_cache[7] || (_cache[7] = _createStaticVNode("<img src=\"" + _imports_0 + "\" class=\"pt-8\" width=\"250\"><div class=\"py-4\"><h3><b>Don&#39;t Have a Confido Legal Account Yet?</b></h3></div><div style=\"width:800px;margin:0 auto;\"><span style=\"width:600px;\"><div class=\"text-left\"> Boost collection rates and reduce the time it takes to get paid by automating the process of requesting and posting online payments through LeanLaw. <b>Law firms who use the Confido Legal integration the most get paid in under five days on average.</b></div><br><div class=\"text-left\"> Accept credit/debit cards and online bank transfers, paying no monthly, setup or termination fees. You can even charge the credit card fees to clients in states where this practice is allowed. All simple, flat-rate transaction fees are clearly outlined on a one-page processing statement, and Confido Legal has a live support team ready to help. </div></span></div>", 3)), _createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(LlSecondaryButton, {
        "aria-label": "Sign up Confido Legal",
        color: "blue-lighten-2",
        style: {
          "padding": "5px",
          "width": "300px",
          "font-size": "14px"
        },
        onBtnClick: _cache[0] || (_cache[0] = $event => signUpToConfido())
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("img", {
          src: _imports_1,
          width: "24"
        }, null, -1), _createElementVNode("span", {
          class: "ml-2",
          style: {
            "padding-left": "5px"
          }
        }, "Sign up to Learn More", -1)]))]),
        _: 1
      }, 512), [[_vShow, !gravityState.enabling]])]), _cache[8] || (_cache[8] = _createElementVNode("h3", null, [_createElementVNode("b", null, "Already Have an Account?")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(LlSecondaryButton, {
        "aria-label": "Login to Confido Legal",
        color: "blue-lighten-2",
        style: {
          "padding": "5px",
          "width": "300px",
          "font-size": "14px"
        },
        onBtnClick: _cache[1] || (_cache[1] = $event => partnerConnect())
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("img", {
          src: _imports_1,
          width: "24"
        }, null, -1), _createElementVNode("span", {
          class: "ml-2",
          style: {
            "padding-left": "5px"
          }
        }, "Login to Confido Legal", -1)]))]),
        _: 1
      }, 512), [[_vShow, !gravityState.enabling]])]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(LlCheckbox, {
        modelValue: gravityState.sandbox,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => gravityState.sandbox = $event),
        label: "Sandbox Account"
      }, null, 8, ["modelValue"])], 512), [[_vShow, _unref(company)?.status == 'test' || _unref(company)?.status == 'internal']])])], 512), [[_vShow, !gravityState.gravity.enabled]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_cache[19] || (_cache[19] = _createElementVNode("img", {
        src: _imports_0,
        width: "250",
        class: "py-8"
      }, null, -1)), _withDirectives(_createElementVNode("div", null, [_createVNode(Loader, {
        what: 'Validating configuration'
      })], 512), [[_vShow, gravityState.validating]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", {
        class: _normalizeClass({
          'bg-green-100 text-center text-base px-2 py-2 rounded-md': gravityState.valid,
          'bg-[rgba(var(--v-theme-error),0.08)] text-center text-base px-2 py-2 rounded-md': !gravityState.valid
        }),
        style: {
          "margin-top": "20px",
          "max-width": "400px",
          "margin": "0 auto"
        }
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [[_vShow, gravityState.validation.customer]]), _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [[_vShow, !gravityState.validation.customer]])]), _createElementVNode("div", _hoisted_10, [_cache[9] || (_cache[9] = _createTextVNode(" Confido Legal Customer Id is ", -1)), _withDirectives(_createElementVNode("span", null, "not", 512), [[_vShow, !gravityState.validation.customer]]), _cache[10] || (_cache[10] = _createTextVNode(" valid ", -1))])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("span", _hoisted_13, null, 512), [[_vShow, gravityState.validation.validToken]]), _withDirectives(_createElementVNode("span", _hoisted_14, null, 512), [[_vShow, !gravityState.validation.validToken]])]), _createElementVNode("div", _hoisted_15, [_cache[11] || (_cache[11] = _createTextVNode(" Confido Legal Access Token is ", -1)), _withDirectives(_createElementVNode("span", null, "not", 512), [[_vShow, !gravityState.validation.validToken]]), _cache[12] || (_cache[12] = _createTextVNode(" valid ", -1))])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("span", _hoisted_18, null, 512), [[_vShow, gravityState.validation.ccProcessing]]), _withDirectives(_createElementVNode("span", _hoisted_19, null, 512), [[_vShow, !gravityState.validation.ccProcessing]])]), _createElementVNode("div", _hoisted_20, [_cache[13] || (_cache[13] = _createTextVNode(" Credit Card Processing is ", -1)), _withDirectives(_createElementVNode("span", null, "not", 512), [[_vShow, !gravityState.validation.ccProcessing]]), _cache[14] || (_cache[14] = _createTextVNode(" enabled ", -1))])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_withDirectives(_createElementVNode("span", _hoisted_23, null, 512), [[_vShow, gravityState.validation.achProcessing]]), _withDirectives(_createElementVNode("span", _hoisted_24, null, 512), [[_vShow, !gravityState.validation.achProcessing]])]), _createElementVNode("div", _hoisted_25, [_cache[15] || (_cache[15] = _createTextVNode(" ACH Processing is ", -1)), _withDirectives(_createElementVNode("span", null, "not", 512), [[_vShow, !gravityState.validation.achProcessing]]), _cache[16] || (_cache[16] = _createTextVNode(" enabled ", -1))])]), _withDirectives(_createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        onClick: _cache[3] || (_cache[3] = $event => validate())
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Validate Again ", -1)]))]),
        _: 1
      })], 512), [[_vShow, !gravityState.valid]])], 2), _createElementVNode("div", _hoisted_26, [_createVNode(LlSecondaryButton, {
        color: "error",
        disabled: gravityState.saving,
        onClick: _cache[4] || (_cache[4] = $event => disable())
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" Disable ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])], 512), [[_vShow, !gravityState.validating]])])], 512), [[_vShow, gravityState.gravity.enabled]])], 64);
    };
  }
};